import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomHeader = (props) => (
  <Header {...props}>
    Gatsby theme&nbsp;<span>Carbon</span>
  </Header>
);

export default CustomHeader;
